<template>
  <draggable
    v-model="draggableGradeLevels"
    handle=".handle"
    v-bind="dragOptions"
    @sort="didMove"
    @start="drag = true"
    @end="drag = false"
    easing="cubic-bezier(1, 0, 0, 1)"
  >
    <transition-group type="transition" :move-class="drag ? 'transform transition-all duration-0' : 'transform transition-all duration-300'">
    <slot v-for="gradeLevel in draggableGradeLevels" :gradeLevel="gradeLevel" :dragging="drag"></slot>
    </transition-group>
  </draggable>
</template>

<script>
import { tz }           from '@/tz'

import draggable from 'vuedraggable'
import gql       from 'graphql-tag'
import _nth      from 'lodash-es/nth'
import _get      from 'lodash-es/get'
import _sortBy   from 'lodash-es/sortBy'

export default {
  components: {
    draggable
  },

  props: ['gradeLevels'],

  data () {
    return {
      draggableGradeLevels: this.gradeLevels,
      drag: false
    }
  },

  computed: {
    maxIndex () {
      return this.gradeLevels.length - 1
    },

    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },

  watch: {
    gradeLevels: function () {
      this.draggableGradeLevels = _sortBy(this.gradeLevels, 'order')
    }
  },

  methods: {
    didMove ({newIndex, oldIndex}) {
      const movedItem = _nth(this.draggableGradeLevels, newIndex)
      const movedItemId = _get(movedItem, 'id')
      var newNumerator = undefined
      var newDenominator = undefined

      if (newIndex == 0) {
        const right = _nth(this.draggableGradeLevels, newIndex + 1)
        newNumerator = _get(right, 'orderNumerator')
        newDenominator = _get(right, 'orderDenominator') + 1
      } else if (newIndex == this.maxIndex) {
        const left = _nth(this.draggableGradeLevels, newIndex - 1)
        newNumerator = _get(left, 'orderNumerator') + 1
        newDenominator = _get(left, 'orderDenominator')
      } else {
        const left = _nth(this.draggableGradeLevels, newIndex - 1)
        const right = _nth(this.draggableGradeLevels, newIndex + 1)
        newNumerator = _get(left, 'orderNumerator') + _get(right, 'orderNumerator')
        newDenominator = _get(left, 'orderDenominator') + _get(right, 'orderDenominator')
      }

      this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!, $numerator: Int!, $denominator: Int!) {
            gradeLevelUpdate (id: $id, gradeLevel: {orderNumerator: $numerator, orderDenominator: $denominator}) {
              canCurrentDelete
              name
              color {
                id
                name
              }
              icon {
                id
                name
              }
              id
              order
              orderDenominator
              orderNumerator
              studentCount
              team {
                id
                name
              }
            }
          }
        `,
        variables: {
          id: movedItemId,
          numerator: newNumerator,
          denominator: newDenominator,
          tz: tz()
        }
      }).then((data) => {
        console.log('Cardstock: SortableGradeLevels successful GradeLevelUpdate')
      }).catch((error) => {
        console.log('Cardstock: SortableGradeLevels nhandleable error on GradeLevelUpdate')
      })
    }
  }
}
</script>
